
/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import { SeoComponent } from '../components/Header/SeoComponent';
import Grid from '@material-ui/core/Grid'
import { withTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import ReactHtmlParser from 'react-html-parser';
import { GET_PAGE } from "../queries";
import { useThemeData } from '../context/ThemeDataContext'


function Page(props) {
  const { site_id, site_name, favicon } = useThemeData().themeData.site
  const { loading: loadingPage, error: errorPage, data: dataPage } =
    useQuery(GET_PAGE, {
      variables: {
        site_id: site_id,
        url: props.match.params.page
      },
      fetchPolicy: 'cache-and-network'
    })

  if (loadingPage) return <p>{props.t('Loading...')}</p>
  if (errorPage) return <p>{props.t('Looks like we have a problem...')}</p>
  if (!dataPage) return null

  const html = dataPage.page.tekst

  return (
    <Grid container direction="row" className="container page">
      <SeoComponent site_name={site_name} favicon={favicon} title={dataPage.page.naam} omschrijving={dataPage.page.omschrijving}/>
        <Grid item xs={12} style={{display: 'inline', textAlign: 'left'}}>
      {ReactHtmlParser(html)}
        </Grid>
    </Grid>
  )
}

export default React.memo(withTranslation('message')(Page));
